(function () {
  "use strict";

  class ConvxSlider extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.resizeHandler = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.initFlickityWithRetry();
      window.addEventListener("resize", this.resizeHandler);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.resizeHandler);
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }
    }

    getFlickityOptions() {
      const defaultOptions = window.innerWidth < 768
        ? { cellAlign: "center", contain: true, groupCells: true, imagesLoaded: true }
        : { cellAlign: "left", contain: true, groupCells: false, imagesLoaded: true };

      // Get custom options from data attribute
      let customOptions = {};
      try {
        const optionsString = this.getAttribute('data-options');
        if (optionsString) {
          customOptions = JSON.parse(optionsString);
        }
      } catch (error) {
        console.warn('Invalid data-options format:', error);
      }

      // Merge default options with custom options
      return { ...defaultOptions, ...customOptions };
    }

    initFlickityWithRetry(attemptsLeft = 200) {
      if (typeof Flickity === "undefined") {
        if (attemptsLeft <= 0) return;
        requestAnimationFrame(() => this.initFlickityWithRetry(attemptsLeft - 1));
        return;
      }
      this.initFlickity();
    }

    initFlickity() {
      if (typeof Flickity === "undefined") return;

      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
      this.flickityInstance = new Flickity(this, this.getFlickityOptions());
    }

    handleResize() {
      if (!this.flickityInstance) {
        this.initFlickityWithRetry();
        return;
      }

      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if (!this.flickityInstance) return;
        this.flickityInstance.resize();
        this.flickityInstance.reloadCells();
      }, 150);
    }
  }

  function onDOMContentLoaded() {
    if (!customElements.get("convx-slider")) {
      customElements.define("convx-slider", ConvxSlider);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
